import React, { createContext, useContext, useMemo, useState } from 'react'

import { ReplayContextProvider } from './HistoricalReplay/ReplayContext'

export type OperationMapContextType = {
  widgetId: `Map-${string}`
  setWidgetId: (widgetId: `Map-${string}`) => void
}

export const OperationMapContext = createContext<OperationMapContextType>({
  widgetId: 'Map-',
  setWidgetId: () => { },
})

export const useOperationMapContext = () => {
  const context = useContext(OperationMapContext)

  if (context === undefined) {
    throw new Error(
      'useOperationMapContext must be used within a OperationsMapWidgetContextProvider',
    )
  }

  return context
}

/**
 * The OperationsMapWidgetContextProvider is a context provider that help share the state
 *    between the OperationsMapWidget and the OperationsMapWidgetToolbar components through
 *    the Mosaic Window rendering. Thus, any local actions or state that need to be shared
 *    between these two components should be managed here.
 */
export type OperationsMapWidgetContextProps = {
  children?: React.ReactNode
}

export const OperationsMapWidgetContextProvider: React.FC<OperationsMapWidgetContextProps> = ({ children }) => {
  const [widgetId, setWidgetId] = useState<`Map-${string}`>('Map-')

  const contextValue = useMemo(() => {
    return {
      widgetId,
      setWidgetId,
    }
  }, [widgetId])

  return (
    <OperationMapContext.Provider value={contextValue}>
      <ReplayContextProvider>
        {children}
      </ReplayContextProvider>
    </OperationMapContext.Provider>
  )
}
